import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function PaymentCancel() {
  const navigate = useNavigate();
  const { t } = useLang();
  return (
    <div className="min-h-screen bg-decide-canvas flex flex-col items-center justify-center px-6 text-center" data-testid="payment-cancel">
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-decide-mist">
        <XCircle size={38} className="text-decide-slate" />
      </div>
      <h1 className="mt-6 text-2xl font-medium text-decide-ink">{t("payment.cancelTitle")}</h1>
      <p className="mt-2 text-decide-slate">{t("payment.cancelSub")}</p>
      <div className="mt-8 flex gap-3">
        <button onClick={() => navigate("/pricing")} className="btn-accent">{t("payment.backPricing")}</button>
        <button onClick={() => navigate("/app")} className="btn-secondary">{t("payment.goHome")}</button>
      </div>
    </div>
  );
}
